module.exports = __webpack_public_path__ + "static/media/ridelightpro-3.2f2be8e9.jpg";